export const APP_CONTAINER_ID = 'app';
